const jsonToProps = ({ id, wishlist, isBookmarked }) => ({
  id,
  gift_registry: wishlist?.gift_registry ? wishlist?.gift_registry : null,
  isBookmarked,
});

export default jsonToProps;
